import {
  StyleSheet,
  ImageBackground,
  SafeAreaView,
  useWindowDimensions,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  View,
  ScrollView,
  Text,
  Heading,
  Box,
  VStack,
  HStack,
  Pressable,
} from "native-base";
import { StackScreenProps } from "../../types";
import Card, { CardProps } from "../../components/Card";
import { LinearGradient } from "expo-linear-gradient";
import Header from "../../components/Header";
import CountUp from "react-countup";
import AsyncStorage from "@react-native-async-storage/async-storage";

const Media = ({ navigation }: StackScreenProps<"Media">) => {
  const { width, height } = useWindowDimensions();
  const fftv = require("../../assets/fortune_tv.png");
  const ffr = require("../../assets/fortune_radio.png");

  const [data, setData] = useState({});
  useEffect(() => {
    async function getData() {
      const items = await AsyncStorage.getItem("keyFigures");

      if (items) {
        try {
          setData(JSON.parse(items));
          // console.log(JSON.parse(items));
        } catch (error) {
          console.log(error);
        }
      }
    }

    getData();
  }, []);

  return (
    <ImageBackground source={fftv} resizeMode="cover" style={{ width, height }}>
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView>
            <Header
              onPress={() => navigation.navigate("Media")}
              parentText="Media"
              headingText="Farm & Fortune TV Show"
            />

            <Text mb={5} textAlign="center" fontWeight={"bold"}>
              Key figures:
            </Text>

            <Box
              width={"5/6"}
              // h="16"
              mb={5}
              marginX="auto"
              // borderBottomColor="#000"
              borderColor={"#ccc"}
              borderWidth="1"
              borderRadius={15}
              p={5}
              pb={2}
            >
              <HStack justifyContent={"space-between"}>
                <View>
                  <Text fontWeight={"extrabold"} fontSize="2xl">
                    <CountUp
                      delay={0}
                      end={data["ffhtv_1"]}
                      duration={3}
                      suffix="M+"
                    />
                  </Text>
                  <Text fontWeight={"bold"}>Listeners</Text>
                </View>
                <View>
                  <Text fontWeight={"extrabold"} fontSize="2xl">
                    <CountUp delay={0} end={data["ffhtv_2"]} />
                  </Text>
                  <Text fontWeight={"bold"}>Episodes</Text>
                </View>
                <View>
                  <Text fontWeight={"extrabold"} fontSize="2xl">
                    <CountUp delay={0} end={data["ffhtv_3"]} />
                  </Text>
                  <Text fontWeight={"bold"}>Crops</Text>
                </View>
              </HStack>
            </Box>

            <Text textAlign="center" px={5}>
              The Farm & Fortune TV show aims to amplify best farm practices,
              soil testing & fertilizer recommendation by inviting experts to
              share knowledge and experiences. The show is filmed in and around
              Nigeria; blended with a multi-presenter studio format and aired in
              30-minute episodes.{" "}
            </Text>

            <View mt={10}></View>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default Media;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#221919b8",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
  },
});
